import classNames from 'classnames';

const Paragraph = ({text, ParagraphClassName}: IRoleParagraphProps) => {
  return (
    <p
      className={classNames(
        'leading-10 text-justify text-[16px] text-gray-6',
        ParagraphClassName,
      )}
    >
      {text}
    </p>
  );
};

export default Paragraph;
